import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { type ThemeConfig, THEME_CONFIG } from './theme-config';
import { ThemeService } from './theme';

/**
 * Registers theme storage config and applies the persisted preference at boot.
 *
 * Pair with `theme-boot.js` in `index.html` (same `storageKey` via
 * `data-storage-key`) to avoid a light→dark flash before Angular loads.
 * Keep that script external so CloudFront CSP `script-src 'self'` stays valid
 * (see `optimization.styles.inlineCritical: false` in angular.json).
 */
export function provideTheme(config: ThemeConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: THEME_CONFIG, useValue: config },
    provideAppInitializer(() => {
      inject(ThemeService);
    }),
  ]);
}
